import request from '@/utils/request'

/**
 * 查询任务模板列表
 * @param {Object} params 
 * @returns 
 */
export function listTaskTemplate(params) {
  return request({
    url: '/task/taskTemplate/list',
    method: 'GET',
    params,
  })
}

/**
 * 查询单个任务
 * @param {Object} params 
 * @returns 
 */
export function getTaskTemplateInfo(_id) {
  return request({
    url: '/task/taskTemplate/findOne',
    method: 'GET',
    params: {
      _id,
    },
  })
}

/**
 * 添加任务模板
 * @param {Object} data 
 * @returns 
 */
export function addTaskTemplate(data) {
  return request({
    url: '/task/taskTemplate/insert',
    method: 'POST',
    data,
  })
}


/**
 * 修改任务
 * @param {Object} data 
 * @returns 
 */
export function updateTaskTemplate(data) {
  return request({
    url: '/task/taskTemplate/update',
    method: 'POST',
    data,
  })
}

/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function removeTaskTemplate(data) {
  return request({
    url: '/task/taskTemplate/remove',
    method: 'POST',
    data,
  })
}





